import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadInvoices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7.75293V16.7529",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2422 12.7529L11.9995 16.9956L7.75691 12.7529",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 5.00468C18.4485 6.33868 20.5 9.30623 20.5 12.7529C20.5 17.4474 16.6944 21.2529 12 21.2529C7.30558 21.2529 3.5 17.4474 3.5 12.7529C3.5 9.30622 5.55149 6.33865 8.50002 5.00466L8.50001 3.38254C4.70334 4.80127 2 8.4614 2 12.7529C2 18.2758 6.47715 22.7529 12 22.7529C17.5228 22.7529 22 18.2758 22 12.7529C22 8.46141 19.2967 4.80129 15.5 3.38255L15.5 5.00468Z",
			fill: "#4D5055"
		})
	]
});
export default SvgDownloadInvoices;
